import {UserCreateModel} from '../../shared/services/user/user.create.model';
import {UserModel} from '../../shared/services/user/user.model';
import {UserPasswordModel} from '../../shared/services/user/user.password.model';

export class GetUsers {
  static readonly type = '[user] get users';
  constructor(public page?: number, public size?: number, public userName?: string) {}
}

export class CreateUser {
  static readonly type = '[user] create user';
  constructor(public user: UserCreateModel) {}
}

export class DeleteUser {
  static readonly type = '[user] delete user';
  constructor(public userName: string) {}
}

export class UpdateUser {
  static readonly type = '[user] update user';
  constructor(public user: UserModel, public userName: string) {}
}

export class UpdateUserPassword {
  static readonly type = '[user] update user password';
  constructor(public password: UserPasswordModel, public userName: string) {}
}
